'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file localStorage封装
 */

var localStorage = global.localStorage;

if (!localStorage) {

  localStorage = global.localStorage = {};
  global.localstorage_cache = {};

  localStorage.setItem = function (key, value) {
    global.localstorage_cache[key] = value;
  };

  localStorage.getItem = function (key) {
    return global.localstorage_cache[key];
  };

  localStorage.removeItem = function (key) {
    delete global.localstorage_cache[key];
  };
}

exports.default = {
  /**
   * 设置本地缓存
   * @param {string} name - 键名
   * @param {*} data - 键值
   */
  setItem: function setItem(name, data) {
    try {
      if (data instanceof String) {
        return localStorage.setItem(name, data);
      }
      localStorage.setItem(name, JSON.stringify(data));
    } catch (e) {
      throw new Error('存储失败');
    }
  },


  /**
   * 获取本地缓存
   * @param {string} name - 键名
   * @returns {*} 键值
   */
  getItem: function getItem(name) {
    try {
      // 默认返回json
      return JSON.parse(localStorage.getItem(name));
    } catch (err) {
      return localStorage.getItem(name);
    }

    return null;
  },


  /**
   * 删除本地缓存
   * @param {string} name - 键名
   */
  removeItem: function removeItem(name) {
    localStorage.removeItem(name);
  },


  /**
   * 删除所有本地缓存
   */
  clear: function clear() {
    localStorage.clear();
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/store/localStorage.js
// module id = 453
// module chunks = 14